
import { loadFormConfigWithSteps } from './formConfigLoader';
import { MoldOrder, MoldOrderFirstLevelType } from '../../types/mold';
import { simpleFilterSections } from './simpleFilterUtils';
import { QuestionFilterStrategy } from '../../types/form';

export const getFormConfig = async (moldOrder: MoldOrder, moldOrderGroup: MoldOrderFirstLevelType) => {
  // Returns only the sections and questionFilterStrategy for backward compatibility
  const loaded = await loadFormConfigWithSteps(moldOrder, moldOrderGroup);
  
  // Use the enhanced filtering function which handles both legacy status-based filtering 
  // and new moldOrder rule-based filtering. When no moldOrderRules are present,
  // it automatically falls back to legacy behavior.
  const filteredSections = simpleFilterSections(
    loaded.sections,
    moldOrder.status,
    moldOrder,
    loaded.questionFilterStrategy as QuestionFilterStrategy
  );
  
  return {
    ...loaded,
    steps: loaded.steps,
    sections: filteredSections,
    allSections: loaded.sections,
    questionFilterStrategy: loaded.questionFilterStrategy,
  };
};

export const getFormVersion = (moldOrder: MoldOrder): string => {
  // For all mold orders in production that does not have formVersion, use the first version
  if (moldOrder?.orderDetail?.formVersion) {
    return moldOrder?.orderDetail?.formVersion;
  }
  return '1.0';
}